// SPDX-License-Identifier: AGPL-3.0-or-later

import GuildMembers from '@app/features/member/state/GuildMembers';
import styles from '@app/features/theme/styles/Message.module.css';
import {Tooltip} from '@app/features/ui/tooltip/Tooltip';
import * as DateUtils from '@app/features/user/utils/dateFormatting';
import {formatShortRelativeTime} from '@app/vendor/date_utils/DateDuration';
import {Trans, useLingui} from '@lingui/react/macro';
import {ClockIcon} from '@phosphor-icons/react';
import {observer} from 'mobx-react-lite';

interface MessageTimeoutIndicatorProps {
	guildId: string | null | undefined;
	userId: string | null | undefined;
}
export const MessageTimeoutIndicator = observer(({guildId, userId}: MessageTimeoutIndicatorProps) => {
	const {t} = useLingui();
	const timeoutUntil = GuildMembers.getCommunicationDisabledUntil(guildId ?? null, userId);
	if (!timeoutUntil) return null;
	return (
		<Tooltip
			text={() => (
				<Trans>
					Timeout ends {formatShortRelativeTime(timeoutUntil)} ({DateUtils.getFormattedDateTime(timeoutUntil)})
				</Trans>
			)}
			position="top"
			maxWidth="none"
		>
			<span className={styles.messageTimeoutIndicator} role="img" aria-label={t`Timed out`}>
				<ClockIcon size={16} weight="bold" />
			</span>
		</Tooltip>
	);
});
